<template>
  <div class="sweeper111">
    <div class="introduce">
      <div class="detailed detailed1">
        <div class="left container">
          <div class="content white">
            <h3></h3>
            <h4>Sweeper 111 {{this.$t('sweeper111.sweeper111')}}</h4>
            <p>
              {{this.$t('sweeper111.RobotsForCleaning')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="video">
      <video
        src="https://enway-official.s3.ap-northeast-1.amazonaws.com/enway-video/2-5/S111.40331f10.mp4"
        controls
        autoplay
        muted
        loop
        width="100%"
      ></video>
    </div>
    <div class="parameter container">
      <img
        class="photo"
        src="../../assets/sweeper111/Specifications-Img-Vacuum-40-min-1.0591186c.png"
        alt=""
      />
      <div class="message">
        <h4 class="title">{{this.$t('sweeper111.Sweeper111Specification')}}</h4>
        <p>
          <span class="textRight">{{this.$t('sweeper111.ProductSize')}}</span
          ><span>1530（L）* 1010（W）* 1400（H）mm</span>
        </p>
        <p>
          <span class="textRight">{{this.$t('sweeper111.BatteryCapacity')}}</span
          ><span>Li-ion 240 Ah</span>
        </p>
        <p><span class="textRight">{{this.$t('sweeper111.ContinuousUptime')}}</span><span>4-7 h</span></p>
        <p><span class="textRight">{{this.$t('sweeper111.KiyoaraiWidth')}}</span><span>1100 mm</span></p>
        <p><span class="textRight">{{this.$t('sweeper111.TurningAngle')}}</span><span>±60°</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang='less'>
.sweeper111 {
  .introduce {
    .container {
      display: flex;
      align-items: center;
      height: 700px;
      .white {
        color: #fff;
      }
      h3 {
        width: 512px;
        font-size: 30px;
      }
      h4 {
        width: 700px;
        font-size: 44px;
        font-weight: 700;
      }
      p {
        margin-top: 40px;
        display: inline-block;
        width: 700px;
        font-size: 16px;
      }
    }
    .left {
      display: flex;
      justify-content: flex-start;
    }
    .right {
      color: #000000;
      display: flex;
      justify-content: flex-end;
    }
    .detailed {
      background: no-repeat center;
      background-size: cover;
    }
    .detailed1 {
      background-image: url("~@/assets/sweeper111/Smart-Obstacle-Avoidance-D.-min.7b920454.png");
    }
  }
  .video {
    padding: 60px 150px;
  }
  .parameter {
    box-sizing: border-box;
    height: 647px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .photo {
      flex-shrink: 0;
      width: 577px;
      height: 560px;
    }
    .message {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      height: 347px;
      h4 {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        line-height: 100px;
      }
      p {
        padding: 10px;
        font-size: 16px;
        color: #000;
        line-height: 1.2;
        display: flex;
        span {
          color: #0064e6;
          line-height: 24px;
        }
        .textRight {
          flex-shrink: 0;
          width: 210px;
          text-align: right;
          color: #000;
        }
        span:last-child{
          margin-left: 40px;
        }
      }
    }
  }
  // 当屏幕宽度小于860px时
  @media screen and (max-width: 860px) {
    .introduce {
      h3 {
        width: 100% !important;
        font-size: 20px !important;
      }
      h4 {
        width: 100% !important;
        font-size: 26px !important;
      }
      p {
        width: 100% !important;
      }
      .content {
        padding: 0 10px;
        width: 100%;
      }
      .container {
        height: 400px !important;
      }
    }
    .video {
      padding: 0;
    }
    .parameter {
      padding: 30px 20px;
      width: unset !important;
      height: unset !important;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: center;
      .photo {
        width: 100%;
        height: unset;
      }
      .message {
        height: unset;

        h4 {
          font-size: 16px !important;
        }
        p {
          width: 100%;
          font-size: 18px !important;
          span {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
